import { useMutation } from '@tanstack/react-query';

import { TOASTTYPE, useToast } from '@/ui/Toast/Toast';
import { fetcher } from '@/utils/fetcher';
import { RETAIL_API_URL } from 'src/utils/envConfig';

import { useIntl } from 'react-intl';
import { Unit } from '@/types/Unit';

export const useRestart = (unitId: Unit['id'] | undefined) => {
  const toast = useToast();
  const intl = useIntl();
  const {
    mutateAsync: restartDevices,
    isPending: isLoading,
    error,
  } = useMutation({
    mutationFn: async () => {
      const response = await fetcher<{
        readonly success?: boolean;
      }>(`${RETAIL_API_URL}/units/restart?unitId=${unitId}`, {
        method: 'POST',
      });

      if (!response?.success) {
        toast({
          title: intl.formatMessage({
            defaultMessage:
              'Failed to restart one or more devices, make sure they are online!',
            id: 'rWlSDa',
          }),
          mode: TOASTTYPE.Danger,
        });
        throw response.success;
      }
    },
    onSuccess: () => {
      toast({
        subtitle: intl.formatMessage({
          defaultMessage: 'The devices have been restarted.',
          id: 'e4Jlff',
        }),
        mode: TOASTTYPE.Success,
      });
    },
  });

  return { restartDevices, isLoading, error };
};
